module.exports = __webpack_public_path__ + "static/media/README.cd9597c3.md";